import { Tab } from '@headlessui/react'
import classNames from 'classnames'

const reviews = {
  average: 4,
  featured: [
    {
      id: 1,
      rating: 5,
      content: `
        <p>This icon pack is just what I need for my latest project. There's an icon for just about anything I could ever need. Love the playful look!</p>
      `,
      date: 'July 16, 2021',
      datetime: '2021-07-16',
      author: 'Emily Selman',
      avatarSrc:
        'https://images.unsplash.com/photo-1502685104226-ee32379fefbe?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=256&h=256&q=80',
    },
    {
      id: 2,
      rating: 5,
      content: `
        <p>Blown away by how polished this icon pack is. Everything looks so consistent and each SVG is optimized out of the box so I can use it directly with confidence. It would take me several hours to create a single icon this good, so it's a steal at this price.</p>
      `,
      date: 'July 12, 2021',
      datetime: '2021-07-12',
      author: 'Hector Gibbons',
      avatarSrc:
        'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=256&h=256&q=80',
    },
  ],
}

const Reviews = () => {
  return (
    <Tab.Panel className='-mb-10'>
      <>
        <h3 className='sr-only'>Customer Reviews</h3>

        {reviews.featured.map((review, reviewIdx) => (
          <div key={review.id} className='flex space-x-4 text-sm text-gray-500'>
            <div className='flex-none py-10'>
              <img
                src={review.avatarSrc}
                alt=''
                className='h-10 w-10 rounded-full bg-gray-100'
              />
            </div>
            <div
              className={classNames(
                reviewIdx === 0 ? '' : 'border-t border-gray-200',
                'py-10',
              )}
            >
              <h3 className='reviewAuthor text-gray-900'>{review.author}</h3>
              <p className='reviewDate'>
                <time dateTime={review.datetime}>{review.date}</time>
              </p>

              <div
                className='custom-font-24 mt-2 max-w-none'
                /* eslint-disable-next-line react/no-danger */
                dangerouslySetInnerHTML={{ __html: review.content }}
              />
            </div>
          </div>
        ))}
      </>
      <style jsx>{`
        .reviewAuthor {
          font-size: calc(16px + (30 - 16) * (100vw - 375px) / (1920 - 375));
          font-weight: 500;
        }
        .reviewDate {
          font-size: calc(10px + (20 - 10) * (100vw - 375px) / (1920 - 375));
          font-weight: 300;
        }
      `}</style>
    </Tab.Panel>
  )
}

export default Reviews
